var exports = {
  "kL": "AudioPlayer.module__container___VC1ibm",
  "Md": "AudioPlayer.module__fileName___VC1ibm",
  "NE": "AudioPlayer.module__progressSection___VC1ibm",
  "hr": "AudioPlayer.module__progressBar___VC1ibm",
  "Ey": "AudioPlayer.module__timeDisplay___VC1ibm",
  "ne": "AudioPlayer.module__controls___VC1ibm",
  "gm": "AudioPlayer.module__mainControls___VC1ibm",
  "Rr": "AudioPlayer.module__playButton___VC1ibm",
  "$3": "AudioPlayer.module__seekButton___VC1ibm",
  "f6": "AudioPlayer.module__secondaryControls___VC1ibm",
  "Wq": "AudioPlayer.module__volumeControl___VC1ibm",
  "Sn": "AudioPlayer.module__playbackRate___VC1ibm",
  "Hw": "AudioPlayer.module__mobile___VC1ibm",
};

module.exports = exports;
